//1.
import React, { useEffect, useState } from 'react';
import { Auth, Amplify } from 'aws-amplify';
//2.
import awsExports from './aws-exports';
//3.
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
// import './Dashboard.css';
import  child from 'child_process';
import { formatElapsedTime } from './commonUtils.js';

//4.
Amplify.configure(awsExports)

/*
function Dashboard() {
 return(
    <Authenticator>
      {({ signOut, user }) => (
        <main>
          <h1>Welcome to WA Capture from Sausalito Labs</h1>
          <p>The easy way to capture your messages for compliance</p>
          <br/>  
          <p>This is a dashboard.</p>
          <ul><li>email: {user.attributes.email}</li>
          <li>username: {user.username}</li>
          </ul>
          <button onClick={signOut}>Sign out</button>
        </main>
      )}
    </Authenticator>
 )
}
*/
/*
function formatElapsedTime(epochTime) {
    const now = Date.now();
    const elapsedMilliseconds = now - epochTime;
  
    // Define time intervals in milliseconds
    const minute = 60 * 1000;
    const hour = 60 * minute;
    const day = 24 * hour;
  
    if (elapsedMilliseconds < minute) {
      const seconds = Math.floor(elapsedMilliseconds / 1000);
      return seconds === 1 ? '1 second ago' : `${seconds} seconds ago`;
    } else if (elapsedMilliseconds < hour) {
      const minutes = Math.floor(elapsedMilliseconds / minute);
      return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
    } else if (elapsedMilliseconds < day) {
      const hours = Math.floor(elapsedMilliseconds / hour);
      return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
    } else {
      const days = Math.floor(elapsedMilliseconds / day);
      return days === 1 ? '1 day ago' : `${days} days ago`;
    }
}
*/
function Dashboard() {
    const [status, setStatus] = useState(null);
    const [isSessionSaved, setIsSessionSaved] = useState(false);
    const [lastCaptureTime, setLastCaptureTime] = useState(null);
    const [updatedTime, setUpdatedTime] = useState(null);
    const [processStarted, setProcessStarted] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [qrCodeURL, setQrCodeURL] = useState('');
    const [isInitButtonContainerVisible, setIsInitButtonContainerVisible] = useState(null);
    const [isFinalButtonContainerVisible, setIsFinalButtonContainerVisible] = useState(null);

    useEffect(() => { 
        Auth.currentAuthenticatedUser()
        .then((user) => {
          setUserEmail(user.attributes.email);

          //setStatus(await fetchLastCaptureStatus(user.attributes.email));
          // Define the API endpoint with the user's email
          const apiUrl = `https://wacap.sausalitolab.com:3030/v0.1/users/${user.attributes.email}/session?username=admin&password=brick-grape-megaton`;

          // Make the API request
          fetch(apiUrl)
            .then((response) => response.json())
            .then((data) => {
              // Extract the session_end_time from the API response
              const { updated_time, status, session_end_time } = data;

              // Set the session_end_time in the component's state
              setStatus(status);
              setUpdatedTime(updated_time);
              console.log("updating status to ", status);
            })
            .catch((error) => {
              console.error('Error fetching session data:', error);
            });

          // Fetch the session_log to get the most recent capture session info
          const apiUrl2 = `https://wacap.sausalitolab.com:3030/v0.1/users/${user.attributes.email}/session_log/latest?username=admin&password=brick-grape-megaton`;

          fetch(apiUrl2)
            .then((response) => {
              if (!response.ok) {
                throw new Error('Failed to fetch session data');
              }
              return response.json();
            })
            .then((data) => {
              if (data && data.session_saved && data.session_recovered) {
                setIsSessionSaved(true);
              } else {
                setIsSessionSaved(false);
              }

              if (data && data.inserted_time) {
                setLastCaptureTime(data.inserted_time);
              } else {
                setLastCaptureTime(0);
              }
            })
            .catch((error) => {
              setIsSessionSaved(false);
              setLastCaptureTime(0);
              console.error('Error fetching session data:', error);
            });

          });

        console.info("window.innerWidth = ", window.innerWidth);         

        if (!isFinalButtonContainerVisible) {
          setIsInitButtonContainerVisible(true);
        }
    }, []); // Empty dependency array as user retrieval is handled asynchronously


    const populateChatroomSelectionTable = (userEmail) => {
      const chatList = document.getElementById('chatList');
      const chatStatsForm = document.getElementById('chatStatsForm');
      fetch(`https://wacap.sausalitolab.com:3030/v0.1/users/${userEmail}/messages/stats?username=admin&password=brick-grape-megaton`)
      .then(async (response) => {
        const data = await response.json();

        if (data && data.length > 0) {
          // Generate HTML to display chat statistics with checkboxes
          const chatHTML = data.map(chat => {
              const chatName = chat.subject || chat.room_id;
              const isChecked = chat.ok_to_capture === null || chat.ok_to_capture ? 'checked' : '';
              // console.log('chatroom found: ', chatName, "; ok_to_capture: ", isChecked);
              return `
                  <tr>
                      <td><input type="checkbox" name="selectedChats" value="${chat.room_id}" ${isChecked}></td>
                      <td>${chatName}</td>
                      <td>${chat.cnt}</td>
                  </tr>
              `;
          }).join('');

          chatList.innerHTML = chatHTML;
        } else {
            chatList.innerHTML = '<tr><td colspan="3">No chat statistics found. <a href="#" onClick={() => populateChatroomSelectionTable({user.attributes.email})}>Retry</a></td></tr>';
        }
      })
      .catch((error) => {
        console.error('Error fetching user data:', error);
      });
    };

        function startChatroomSelectionPrep(userEmail) {
          populateChatroomSelectionTable(userEmail);
          const chatStatsForm = document.getElementById('chatStatsForm');

          chatStatsForm.addEventListener('submit', async function (event) {
              event.preventDefault();

              // Gather all chat IDs and their states
              const chatCheckboxes = document.querySelectorAll('input[name="selectedChats"]');
              const chatStates = {};

              chatCheckboxes.forEach(chatCheckbox => {
                const roomId = chatCheckbox.value;
                const isChecked = chatCheckbox.checked;
                chatStates[roomId] = isChecked;
              });

              // Create an array of JSON structures
              const chatStructures = Object.entries(chatStates).map(([roomId, isSelected]) => ({
                user_id: userEmail,
                room_id: roomId,
                ok_to_capture: isSelected,
              }));

              // Send the array of JSON structures to the server
              try {
                const response = await fetch(`https://wacap.sausalitolab.com:3030/v0.1/groups?username=admin&password=brick-grape-megaton`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(chatStructures),
                });

                if (response.ok) {
                    console.log('Selected chats updated successfully.');
                } else {
                    console.error('Failed to update selected chats.');
                }
              } catch (error) {
                console.error('Error updating selected chats:', error);
              }

              deleteUserMessage(userEmail);
          });
        }


    // Function to handle QR code event source
    const handleQRCodeEventSource = (userEmail) => {
        const qrCodeContainer = document.getElementById('qrcode-container');
        const messageContainer = document.getElementById('message');
        const eventSource = new EventSource(`https://wacap.sausalitolab.com:3030/v0.1/users/${userEmail}/qrcode?username=admin&password=brick-grape-megaton`);

        // sets userEmail
        // setUserEmail(userEmail);

        eventSource.onmessage = (event) => {
            const qrCodeData = JSON.parse(event.data);
            const qrCodeURL = qrCodeData.qr_code;
            const currentTime = Date.now();

            setStatus(prevStatus => (prevStatus != qrCodeData.status ? qrCodeData.status : prevStatus ));
            setQrCodeURL(prevQrCodeData => (prevQrCodeData != qrCodeData.qr_code ? qrCodeData.qr_code : prevQrCodeData ));
            setUpdatedTime(qrCodeData.updated_time);

            if (qrCodeData.status === 'ended') {
              eventSource.close();
              console.log("eventSource closed");
            }
        };
    }; 

    useEffect(() => {
      const qrCodeContainer = document.getElementById('qrcode-container');
      const messageContainer = document.getElementById('message');

      if (!processStarted) {
        return;
      }

      // Create an image element for the QR code
      const qrCodeImage = document.createElement('img');
      qrCodeImage.src = qrCodeURL;
      qrCodeImage.alt = 'QR Code';

      // Remove the previous QR code (if any) and add the new one
      qrCodeContainer.innerHTML = '';
      qrCodeContainer.appendChild(qrCodeImage);
      
      if (status === 'qrcode') {
        messageContainer.innerHTML = 'Ready now! <br></br>Open the WhatsApp on your mobile, go to Settings, then Linked Devices, click a "Link a Device" button<br></br>and point your camera to the QR code';
      } else if (status === 'loading') {
        messageContainer.innerHTML = 'Setting up the environment...';
      } else if (status === 'running') {
        messageContainer.innerHTML = 'Processing the data';
      } else if (status === 'ended') {
        messageContainer.innerHTML = 'Processing complete! You can select the chats to capture:';

        // Change the background color of the second column to greyer color
        document.querySelector('.column:nth-child(2)').style.backgroundColor = '#ccc';

        // stop refreshing the qr code
        setProcessStarted(false);
        
        // Hide the image icon
        const qr_code_image = document.getElementById("qrcode-container");
        if (qr_code_image !== null) { 
          qr_code_image.style.display = "none";
        }

        if (processStarted) {
            Auth.currentAuthenticatedUser()
                .then(async (user) => {
              startChatroomSelectionPrep(user.attributes.email);
            //          setSelectionStarted(true);
            //          console.log(`selectionStarted = ${selectionStarted}`);
              const chatSelectionForm = document.getElementById("chatStatsForm");
              if (chatSelectionForm) {
                chatSelectionForm.style.display = "block";
             }   
            })
            .catch((error) => {
                console.error('Error fetching user data:', error);
            });
        }
      } 
    }, [status, qrCodeURL]);

    // Function to convert milliseconds since epoch to a human-readable date and time
    const formatSessionEndTime = (milliseconds) => {
      //  console.log(`formatting... [${milliseconds}]`);
      const date = new Date(Number(milliseconds));
      const str = date.toLocaleString(); // You can customize the format further
      // console.log(`str = ${str}`);
      return str;
    };
  
    const canNewSessionStart = async (userEmail) => {
      // Your API call logic here
      await fetch(`https://wacap.sausalitolab.com:3030/v0.1/users/${userEmail}/session?username=admin&password=brick-grape-megaton`)
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 'ended') {
            return true;
          } else {
            const sessionUpdatedTime = Number(data.updated_time); // Assuming it's a 13-digit epoch timestamp
            console.log("sessionUpdatedTime: ", sessionUpdatedTime);
            const currentTime = Date.now(); // Convert current time to milliseconds
            const tenMinutesAgo = currentTime - 600000; // 10 minutes ago in milliseconds
            console.log("tenMinsAgo: ", tenMinutesAgo);
            console.log("status: ", data.status);
            console.log("userEmail: ", userEmail);
            console.log("returning ", sessionUpdatedTime < tenMinutesAgo);
            return sessionUpdatedTime < tenMinutesAgo;
          }
        })
        .catch((error) => {
          console.error('Error fetching session data:', error);
          return false;
        });
    };

    function startQRCodePreparation(user) {

      // Disable the button
      // document.getElementById('qrButton').disabled = true;
      // setIsButtonDisabled(true);

      if (canNewSessionStart(user.attributes.email)) {
        // didn't work as expected
        // window.scrollTo({top: 300, behavior: 'smooth'});

        console.log("initiating the lambda wacap session...");
        // Change the background color of the first column to greyer color
        document.querySelector('.column:first-child').style.backgroundColor = '#ccc';

        // Display the message under the heading
        document.getElementById('message').innerHTML = 'Starting up the QR code preparation. Hang on a minute...';

        // Show the loading image
        setTimeout(function() {
            document.getElementById('loadingImage').style.display = 'block';
        }, 1000);

        setTimeout(function() {
            document.getElementById('message').innerHTML = 'Just about there. QR code is coming up soon...';
        }, 5000);

        startProcess();
        setIsInitButtonContainerVisible(false);
      } else {
        document.getElementById('message').innerHTML = 'An earlier session is still lingering. Please retry in a few mins...';
      }
    }


    function deleteUserMessage(userId) {
      const apiUrl = `https://wacap.sausalitolab.com:3030/v0.1/users/${userId}/messages?username=admin&password=brick-grape-megaton`;
    
      // Define the options for the fetch request
      const options = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json', // Set the content type if needed
          // Add any other headers as needed (e.g., authentication headers)
        },
        // You can add a request body if the API expects it
        // body: JSON.stringify({}),
      };
    
      // Send the DELETE request
      return fetch(apiUrl, options)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP Error! Status: ${response.status}`);
          }
          // If the response is successful, you can handle it here
          console.log(`Messages have been deleted successfully.`);
          return response.json(); // If the API returns JSON data in the response
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }


    // Function to start a process by making a PUT request
    const startProcess = () => {
        Auth.currentAuthenticatedUser()
        .then((user) => {
            const apiUrl = `https://wacap.sausalitolab.com:3030/v0.1/users/${user.attributes.email}/session/start?username=admin&password=brick-grape-megaton`;

            fetch(apiUrl, {
            method: 'PUT',
            })
            .then((response) => response.json())
            .then((data) => {
                // Set the PUT response in state to display it
                // setPutResponse(data);
                setProcessStarted(true);

                // Hide the button
                // Assuming you have access to the button element
                const qr_button = document.getElementById("qrButton");

                // Check if the button exists before attempting to hide it
                if (qr_button) { 
                qr_button.style.display = "none";
                }
            })
            .catch((error) => {
                console.error('Error starting the process:', error);
            });
        })
        .catch((error) => {
            console.error('Error fetching user data:', error);
        });
    };

    async function updateUserMobileProfile() {    
      // Fetch the user's 'custom:mobile' attribute from AWS Cognito
      const user = await Auth.currentAuthenticatedUser();
      const attributes = await Auth.userAttributes(user);
      const mobileAttribute = attributes.find(attr => attr.Name === 'custom:mobile');

      // Construct the URL for the PUT request
      const apiUrl = `https://wacap.sausalitolab.com:3030/v0.1/users/${user.attributes.email}/profile?username=admin&password=brick-grape-megaton`;

      // Prepare the PUT request body
      let mobileValue = mobileAttribute ? mobileAttribute.Value : null;

      // Ensure the 'mobile' attribute is 10 digits long and starts with '1'
      if (!mobileValue || !/^\d{11}$/.test(mobileValue)) {
        // Prepend '1' to the 'mobile' attribute
        mobileValue = `1${mobileValue}`;
      }

      // Prepare the PUT request body
      const requestBody = {
        mobile: mobileValue,
      };
    
      // Make the HTTP PUT request
      fetch(apiUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          // Include any other necessary headers
        },
        body: JSON.stringify(requestBody),
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to update user profile');
        }
        return response.json();
      })
      .then(data => {
        // Handle the successful response data here, if needed
        console.log('Profile updated successfully:', data);
      })
      .catch(error => {
        // Handle errors, such as network issues or API failures
        console.error('Error updating user profile:', error);
      });
    }
    

    const skipToReview = () => {
      // Change the background color of the second column to greyer color
      document.querySelector('.column:nth-child(3)').style.backgroundColor = '#ccc';
      
      // Hide the image icon
      const chatStatsForm = document.getElementById("chatStatsForm");
      if (chatStatsForm !== null) { 
        chatStatsForm.style.display = "none";
      }

      const messageContainer = document.getElementById('message');
      messageContainer.innerHTML = 'Great! You can view and export your captured messages'; 

      setIsFinalButtonContainerVisible(true);
      updateUserMobileProfile();
    };

    const handleReviewExport = (userEmail) => {
      // Define the URL with the user's email address as a URL parameter
      const url = `https://ec2-3-138-174-82.us-east-2.compute.amazonaws.com:3000?email=${userEmail}`;
    
      // Open a new tab or window with the specified URL
      const newTab = window.open(url, '_blank');
    
      if (newTab) {
        // The new tab was successfully opened
      } else {
        // The browser blocked the popup, you may want to display an error message
        alert('Popup blocked. Please allow popups for this site.');
      }
    };
    
    useEffect(() => {
        if (processStarted) {
          Auth.currentAuthenticatedUser()
            .then((user) => {
                // Use setTimeout to call handleQRCodeEventSource after 10 seconds
                const timeoutId = setTimeout(() => {
                  handleQRCodeEventSource(user.attributes.email);
                }, 10000); // 10 seconds in milliseconds

                // Clean up the timer when the component unmounts or when processStarted changes
                return () => clearTimeout(timeoutId);
                //handleQRCodeEventSource(user.attributes.email);
            })
            .catch((error) => {
              console.error('Error fetching user data:', error);
            });
        }
    }, [processStarted]);

    return (
      <Authenticator>
        {({ signOut, user }) => (
          <main>

            <div className="container">
                <br></br>
                <h1>Hi {user.attributes.email}, <span className="sign-out-text">(Not you? <a href="#" onClick={signOut}>Sign out</a>)</span>
                &nbsp;&nbsp;&nbsp;&nbsp;Welcome to WhatsApp Capture from Sausalito Labs</h1>
                <p className="centered">The easiest way to capture your messages for compliance</p>
                <br></br><br></br>
                {isSessionSaved && (
                    <div>
                    <p>You have completed the setup. Last capture ran {formatElapsedTime(lastCaptureTime)}.</p>  

                    <div className="button-container">
                            <button className="button" onClick={() => handleReviewExport(user.attributes.email)} id="reviewExportButton">View and Export the captured chat</button>
                            <br></br>
                    </div>
                    <br></br>
                    <p><span className="sign-out-text">(Need to do a new setup? <a href="#" onClick={()=> setIsSessionSaved(false)}>Start now</a>)</span></p>
                  </div>
                )}
                {!isSessionSaved && (
                  <div>
                    <h2>Setting up is as easy as 1-2-3:</h2>
                    <table>
                      <tbody>
                        <tr>
                        <td className="column">1) Request and Scan the QR code using WhatsApp on your mobile phone</td>
                        <td className="column">2) Set your capture preference </td>
                        <td className="column">3) Review and export the captured messages </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="message" id="message"></div>
                </div>
                )}
                {!isSessionSaved && isInitButtonContainerVisible && (
                <div className="button-container">
                    <button className="button" onClick={() => startQRCodePreparation(user)} id="qrButton">Ready to start?&nbsp;&nbsp;Request a QR code</button>
                    <br></br>
                </div>
                )}
                {isFinalButtonContainerVisible && (
                <div className="button-container">
                    <button className="button" onClick={() => handleReviewExport(user.attributes.email)} id="reviewExportButton">Review and Export the captured chat</button>
                    <br></br>
                </div>
                )}
                <div className="loading-image-container" id="qrcode-container">
                    <img width="264" height="264" className="loading-image" id="loadingImage" src="https://media.tenor.com/hQz0Kl373E8AAAAi/loading-waiting.gif" alt="Loading"></img>
                </div>

                <form id="chatStatsForm">
                  <div className="table-container">
                  <table >
                      <thead>
                          <tr>
                              <th>Select to Capture</th>
                              <th>Chat</th>
                              <th>Messages</th>
                          </tr>
                      </thead>
                      <tbody id="chatList">
                      </tbody>
                  </table>
                  </div>
                  <button type="submit">Submit Selected Chats</button>&nbsp;&nbsp;Looks ok, <span className="sign-out-text"><a href="#" onClick={skipToReview}>let's skip</a></span>
                </form>
            </div>

          </main>
        )}
      </Authenticator>
    );
}
  
//6.
export default Dashboard
